import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import formatPercent from '../../../../../util/format_percent';

const propTypes = {
  reportDetails: PropTypes.instanceOf(Map).isRequired,
};

const defaultProps = {};

const TotalsSummaryView = ({ reportDetails }) => (
  <tr key="summary">
    <th>
      <b>TOTALS</b>
    </th>
    <td>-</td>
    <td>-</td>
    <td>
      <b>{reportDetails.get('enrolled') || 0}</b>
    </td>
    <td>
      <b>{reportDetails.get('active') || 0}</b>
    </td>
    <td>
      <b>{reportDetails.get('completed') || 0}</b>
    </td>
    <td>
      <b>{formatPercent(reportDetails.get('overallRetention') || 0)}</b>
    </td>
    <td>
      <b>{formatPercent(reportDetails.get('adjustedRetention') || 0)}</b>
    </td>
    <td>
      <b>{reportDetails.get('totalDropped') || 0}</b>
    </td>
    <td>
      <b>{reportDetails.get('involuntarilyDropped') || 0}</b>
    </td>
    <td>
      <b>{reportDetails.get('voluntarilyDropped') || 0}</b>
    </td>
  </tr>
);

TotalsSummaryView.propTypes = propTypes;
TotalsSummaryView.defaultProps = defaultProps;

export default TotalsSummaryView;
